import { render, staticRenderFns } from "./economics-card.vue?vue&type=template&id=3ac4dd18&scoped=true"
import script from "./economics-card.vue?vue&type=script&lang=js"
export * from "./economics-card.vue?vue&type=script&lang=js"
import style0 from "./economics-card.vue?vue&type=style&index=0&id=3ac4dd18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac4dd18",
  null
  
)

export default component.exports